import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import CorazonPartido from './CorazonPartido.js';
import CuadroEditableClub from './CuadroEditableClub.js';
import EquiposClub from './EquiposClub.js';
import EstadiosClub from './EstadiosClub.js';
import LinksClub from './LinksClub.js';
import MaximosGoleadores from './MaximosGoleadores.js';
import NombresClub from './NombresClub.js';
import PartidosClub from './PartidosClub.js';
import RivalesClub from './historiales/RivalesClub.js';
import TorneosClub from './TorneosClub.js';
import FichaSolapas from '../UI/FichaSolapas.js';
import GrillaResponsiva from '../UI/GrillaResponsiva.js';
import { Cuadro, NombreClub } from '../funciones/FuncionesClub.js';
import useGetURL from '../../hooks/useGetURL.js';
import styles from './DatosClub.module.css';
import MaximasPresencias from './MaximasPresencias.js';

const Solapas = {
  DATOS: 'Datos',
  TORNEOS: 'Torneos',
  PARTIDOS: 'Partidos',
  RIVALES: 'Historiales',
  JUGADORES: 'Jugadores',
};

const listaSolapas = [
  { nombre: Solapas.DATOS, visible: true },
  { nombre: Solapas.TORNEOS, visible: true },
  { nombre: Solapas.PARTIDOS, visible: true },
  { nombre: Solapas.RIVALES, visible: true },
  { nombre: Solapas.JUGADORES, visible: true },
];

const DatosClub = () => {
  const { id: idClub } = useParams();
  const { state } = useLocation();
  const [club, setClub] = useState(null);
  const { isCargando, erroresGet, fetchData, resetErroresGet } = useGetURL();
  const esNuevo = state && state.nuevo;

  useEffect(() => {
    resetErroresGet();
  }, [resetErroresGet]);

  useEffect(() => {
    if (idClub) {
      fetchData('clubes/' + idClub, setClub);
    } else {
      setClub(null);
    }
  }, [fetchData, idClub]);

  const mostrarDatosSolapa = (solapa) => {
    switch (solapa) {
      case Solapas.DATOS: {
        const items = [
          {
            id: 'datos_basicos',
            componente: (
              <CuadroEditableClub cuadro={Cuadro.DATOS_BASICOS} club={club} nuevo={esNuevo} />
            ),
          },
          {
            id: 'fechas',
            componente: <CuadroEditableClub cuadro={Cuadro.FECHAS} club={club} nuevo={esNuevo} />,
          },
          { id: 'nombres', componente: <NombresClub club={club} /> },
          { id: 'links', componente: <LinksClub club={club} /> },
          { id: 'estadios', componente: <EstadiosClub club={club} /> },
          { id: 'equipos', componente: <EquiposClub club={club} /> },
        ];
        // Los primeros 4 items en columna izquierda, los últimos 2 en derecha
        return <GrillaResponsiva items={items} columnaSeparada={4} />;
      }
      case Solapas.TORNEOS: {
        return (
          <div className={`${styles.columnaSimple}`}>
            <TorneosClub club={club} />
          </div>
        );
      }
      case Solapas.PARTIDOS: {
        return (
          <div className={`${styles.columnaSimple}`}>
            <PartidosClub club={club} />
          </div>
        );
      }
      case Solapas.RIVALES: {
        return <RivalesClub club={club} />;
      }
      case Solapas.JUGADORES: {
        const itemsJugadores = [
          { id: 'presencias', componente: <MaximasPresencias club={club} /> },
          { id: 'goleadores', componente: <MaximosGoleadores club={club} /> },
          { id: 'corazon', componente: <CorazonPartido club={club} /> },
        ];
        return <GrillaResponsiva items={itemsJugadores} />;
      }
      default: {
        return null;
      }
    }
  };

  return (
    <FichaSolapas
      item={club}
      titulo={NombreClub(club)}
      solapas={listaSolapas}
      solapaInicial={Solapas.DATOS}
      isCargando={isCargando}
      errores={erroresGet}
      mostrarDatosSolapa={mostrarDatosSolapa}
    />
  );
};

export default DatosClub;
